import React from 'react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-gray-50 border-t border-gray-100 py-12" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0" data-id="element-11">
          <div className="flex flex-col items-center md:items-start" data-id="element-12">
            <img src="https://cdn.magicpatterns.com/uploads/wZMk5yK4oburTmQhCJkL3k/prompt_airtime_logo.png" alt="Prompt Airtime Logo" className="h-8 w-auto mb-4 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-300 cursor-pointer" onClick={() => onNavigate('home')} data-id="element-13" />
            <p className="text-gray-500 text-sm text-center md:text-left max-w-xs" data-id="element-14">
              Simplifying digital airtime purchases across all major networks in
              Kenya.
            </p>
          </div>

          <div className="flex space-x-6" data-id="element-15">
            <button onClick={() => onNavigate('home')} className="text-sm text-gray-500 hover:text-emerald-600 transition-colors" data-id="element-16">
              Home
            </button>
            <button onClick={() => onNavigate('about')} className="text-sm text-gray-500 hover:text-emerald-600 transition-colors" data-id="element-17">
              About
            </button>
            <button onClick={() => onNavigate('services')} className="text-sm text-gray-500 hover:text-emerald-600 transition-colors" data-id="element-18">
              Services
            </button>
            <button onClick={() => onNavigate('contact')} className="text-sm text-gray-500 hover:text-emerald-600 transition-colors" data-id="element-19">
              Contact
            </button>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center" data-id="element-20">
          <p className="text-sm text-gray-400" data-id="element-21">
            © 2026 Prompt Airtime Limited. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-4" data-id="element-22">
            <span className="text-sm text-gray-400 hover:text-gray-600 cursor-pointer" data-id="element-23">
              Privacy Policy
            </span>
            <span className="text-sm text-gray-400 hover:text-gray-600 cursor-pointer" data-id="element-24">
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>;
}